import { Badge, Box, Burger, Container, Flex, Group } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Link } from "@tanstack/react-router";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import LogoTeacher from "../../../components/LogoTeacher/LogoTeacher";
import useIsMobile from "../../../hooks/useIsMobile";
import useSkillsterStore from "../../../store/app";
import AdminOnly from "../AdminOnly/AdminOnly";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import FeedbackButton from "./components/FeedbackButton/FeedbackButton";
import HeaderMenuItems from "./components/HeaderMenuItems";
import OrganizationNavigation from "./components/ListSelects/OrganizationNavigation/OrganizationNavigation";
import SchoolNavigation from "./components/ListSelects/SchoolNavigation/SchoolNavigation";
import Notifications from "./components/Notifications/Notifications";
import OnlineCounter from "./components/OnlineCounter/OnlineCounter";
import ProfileDropdown from "./components/ProfileDropdown/ProfileDropdown";
import classes from "./styles.module.css";

// Tells the customer the school is fictional. Only the demo build has it.
function DemoBadge() {
  const { t } = useTranslation();
  if (import.meta.env.VITE_DEMO !== "true") return null;
  return (
    <Badge color="yellow.4" c="bluegray.9" radius="sm">
      {t("demo.badge")}
    </Badge>
  );
}

function Header() {
  const mobile = useIsMobile();
  const narrowMobile = useMediaQuery(`(max-width: calc(380px)`);
  const mobileMenuOpen = useSkillsterStore((state) => state.mobileMenuOpen);
  const setMobileMenuOpen = useSkillsterStore(
    (state) => state.setMobileMenuOpen,
  );

  if (mobile)
    return (
      <Suspense fallback={<LoadingScreen />}>
        <Container fluid className={classes.container} p={0}>
          <Container p="xs">
            <Group gap="xs" justify="space-between" wrap="nowrap">
              <Group gap="xs" wrap="nowrap">
                <Box component={Link} to="/home/start">
                  <LogoTeacher
                    hideText={narrowMobile}
                    iconSize={40}
                    fontSize={18}
                    color="white"
                  />
                </Box>
                <DemoBadge />
              </Group>

              <Group wrap="nowrap" gap="xs">
                <Group gap={8} wrap="nowrap">
                  <OnlineCounter />
                  <FeedbackButton />
                  <ProfileDropdown />
                  <AdminOnly>
                    <Notifications />
                  </AdminOnly>
                </Group>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid var(--mantine-color-bluegray-7)",
                    borderRadius: 10,
                    padding: 5,
                  }}
                  bg="bluegray.7"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                  <Burger opened={mobileMenuOpen} color="white" size="sm" />
                </Box>
              </Group>
            </Group>
          </Container>
        </Container>
      </Suspense>
    );
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Container fluid className={classes.container} p={0}>
        <Container py={13}>
          <Flex justify="space-between" gap="md">
            <Group style={{ flexGrow: 4 }}>
              <Link to="/home/start">
                <LogoTeacher iconSize={48} fontSize={24} color="white" />
              </Link>
              <DemoBadge />
            </Group>

            <div className={classes.menuItemsWrapper}>
              <HeaderMenuItems />
            </div>

            <Flex
              gap={{ base: "xs", lg: "sm" }}
              align="center"
              justify="flex-end"
              style={{ flexGrow: 1 }}
              wrap="nowrap"
            >
              <Flex
                gap={{ base: "xs", lg: "sm" }}
                h={50}
                align="center"
                justify="flex-end"
                style={{
                  flexGrow: 4,
                  position: "relative",
                  maxWidth: 300,
                }}
                wrap="nowrap"
              >
                <AdminOnly>
                  <OrganizationNavigation />
                </AdminOnly>
                <SchoolNavigation />
              </Flex>
              <Flex
                gap={{ base: "xs", lg: "md" }}
                align="center"
                justify="flex-end"
                style={{ flexGrow: 4 }}
                wrap="nowrap"
              >
                <AdminOnly>
                  <Notifications />
                </AdminOnly>
                <OnlineCounter />
                <FeedbackButton />
                <ProfileDropdown />
              </Flex>
            </Flex>
          </Flex>
        </Container>
      </Container>
    </Suspense>
  );
}

export default Header;
